import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo, useCallback, useEffect, useState } from 'react';
import classNames from 'classnames';
import Icon from 'ziphy-web-shared/basic/assets/images/Icon';
import styles from './ScrollTopButton.module.scss';
const ScrollTopButton = ({ coefficientHeight = 1 }) => {
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const toggleVisible = () => {
            const scrolled = document.documentElement.scrollTop;
            const desiredHeight = window.innerHeight * coefficientHeight;
            if (scrolled > desiredHeight) {
                setVisible(true);
            }
            else if (scrolled <= desiredHeight) {
                setVisible(false);
            }
        };
        window.addEventListener('scroll', toggleVisible);
        return () => window.removeEventListener('scroll', toggleVisible);
    }, []);
    const scrollToTop = useCallback(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);
    return (_jsx("div", Object.assign({ className: classNames(styles.wrapper, { [styles.visible]: visible }), onClick: scrollToTop }, { children: _jsx(Icon, { type: 'scrollTop' }) })));
};
export default memo(ScrollTopButton);
